import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CopModuleState, copModuleKey } from './cop.reducer';
import * as fromCop from './cop.reducer';

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectCopState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.cop);

export const selectSelectedMapState = createSelector(selectCopState, fromCop.getCurrentMapState);
export const selectSelectedMapUId = createSelector(selectCopState, fromCop.getCurrentMapUId);
export const selectLayers = createSelector(selectCopState, fromCop.getMapLayers);
export const selectWeatherFolders = createSelector(selectCopState, fromCop.getMapWeatherFolders);
export const selectMaps = createSelector(selectCopState, fromCop.getMaps);
export const selectMapSettings = createSelector(selectCopState, fromCop.getMapSettings);
export const selectMapPosition = createSelector(selectCopState, fromCop.getMapPosition);
export const selectMapSettingsFromStorageToLoad = createSelector(selectCopState, fromCop.getMapSettingsFromStorageToLoad);
export const selectSelectedMapTileLayers = createSelector(selectCopState, fromCop.getSelectedMapTileLayers);
export const selectIsMapDirty = createSelector(selectCopState, fromCop.getIsMapDirty);
export const selectIsMapEdit = createSelector(selectCopState, fromCop.getIsMapEdit);
export const selectPreviouslySelectedMapUId = createSelector(selectCopState, fromCop.getPreviouslySelectedMapUId);
export const selectDatasetsSet = createSelector(selectCopState, fromCop.getDatasetsSet);
export const selectSelectedDocuments = createSelector(selectCopState, fromCop.getSelectedDocuments);
export const selectShowMapRoomDialog = createSelector(selectCopState, fromCop.getShowMapRoomDialog);
export const selectMapLinks = createSelector(selectCopState, fromCop.getMapLinks);
export const selectMapLayerViews = createSelector(selectCopState, fromCop.getMapLayerViews);
export const selectCollaboratorsForMapRoom = createSelector(selectCopState, fromCop.getCollaboratorsForMapRoom);
export const selectFloorValues = createSelector(selectCopState, fromCop.getFloorValues);
export const selectSelectedFloor = createSelector(selectCopState, fromCop.getSelectedFloor);
export const selectIsMapLoading = createSelector(selectCopState, fromCop.getIsMapLoading);
export const selectSelectedMapForDelete = createSelector(selectCopState, fromCop.getSelectedMapForDelete);

export const selectIsMapWallEdit = createSelector(selectCopState, fromCop.getIsMapWallEdit);
export const selectShowNightLayer = createSelector(selectCopState, fromCop.getShowNightLayer);
export const selectIsOverviewMode = createSelector(selectCopState, fromCop.getIsOverviewMode);

export const selectLinkDocumentUId = createSelector(selectCopState, fromCop.getLinkDocumentUId);
export const selectLinkDocumentDatasetUId = createSelector(selectCopState, fromCop.getLinkDocumentDatasetUId);

export const selectHistoryTrackEnabledUIds = createSelector(selectCopState, fromCop.getHistoryTrackEnabledUIds);

export * from '../lsd/lsd.selectors';
